// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
type Props = {
  mediaUrl: string,
}

class KeepeekMedia360 extends React.Component<Props> {
  pannellumViewer = null;

  componentDidMount() {
    this.fetchKeepeekMediaIntoComponent(this.props.mediaUrl);
  }

  shouldComponentUpdate(nextProps: Props): boolean {
    if (this.props.mediaUrl !== nextProps.mediaUrl) {
      this.fetchKeepeekMediaIntoComponent(nextProps.mediaUrl);
    }
    return true;
  }

  componentWillUnmount() {
    if (this.pannellumViewer) {
      this.pannellumViewer.destroy();
    }
  }


  fetchKeepeekMediaIntoComponent = (mediaUrl: string) => {
    if (mediaUrl) {
      if (this.pannellumViewer) {
        this.pannellumViewer.destroy();
      }
      // $FlowFixMe
      this.pannellumViewer = pannellum.viewer('panorama', {
        type: 'equirectangular',
        panorama: mediaUrl,
        autoLoad: true,
      });
    }
  };

  render() {
    return (
      <div className="image-360-container" id="panorama" />
    );
  }
}

export default withRouter(KeepeekMedia360);
